//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'ABBP',
  data() {
    return {
      form: {
        item1: '',
        item2: '',
      },
      hasScore: false,
      disabled: false,
      text: ''
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let result = form.item1 / form.item2
        if (result > 1.3 || form.item1 > 200) {
          self.text = '动脉钙化严重，应检测足趾血压'
        } else if (result >= 0.91 && result <= 1.3) {
          self.text = '下肢动脉正常'
        } else if (result >= 0.71 && result <= 0.9) {
          self.text = '下肢有轻度动脉疾病'
        } else if (result >= 0.4 && result <= 0.7) {
          self.text = '下肢有中度动脉疾病'
        } else if (result < 0.4) {
          self.text = '下肢有重度动脉疾病'
        } else if (result > 1.3) {
          self.text = '动脉钙化严重，应检测足趾血压'
        }
        self.hasScore = true
        return String(result.toFixed(2))
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/ABBP.vue